import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../api/request";

export const getDashboardStats = () => {
  return getRequest("/dashboard/stats");
};

export const getDashboardOverview = () => {
  return getRequest("/dashboard/overview");
};
